// Logs errors without the request they came from. axios (and superagent, used
// by the Mailchimp client) errors carry the sent body and headers, so logging
// the whole error writes customer emails and Authorization tokens to the logs.

const EMAIL_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi

export function maskEmails(text) {
  return `${text}`.replace(EMAIL_PATTERN, '[email]')
}

// "METHOD host/path" of the request that failed, without the query string
function getRequestTarget(config) {
  if (!config?.url) {
    return null
  }

  try {
    const url = new URL(config.url, config.baseURL)
    const method = (config.method ?? 'get').toUpperCase()
    return `${method} ${url.host}${url.pathname}`
  } catch {
    return null
  }
}

/**
 * The parts of an error that are safe to log: name, message, code, HTTP
 * status and the host and path it was sent to. Never the request body,
 * headers or response.
 */
export function describeError(error) {
  if (!(error instanceof Error)) {
    return {
      message: maskEmails(typeof error === 'string' ? error : 'Unknown error')
    }
  }

  const details = {
    name: error.name,
    message: maskEmails(error.message)
  }

  if (error.code !== undefined) {
    details.code = error.code
  }

  const status = error.response?.status ?? error.status ?? error.statusCode
  if (status !== undefined) {
    details.status = status
  }

  const target = getRequestTarget(error.config)
  if (target) {
    details.request = target
  }

  return details
}

export function logError(label, error) {
  // eslint-disable-next-line no-console
  console.error(label, describeError(error))
}
